module.exports = __webpack_public_path__ + "img/erp-logos_0009_storefeeder.e259c1de.jpg";